import { getFullUrl } from '@golden/getch';
const maxDelay = 1000;
function getApiEntry(url) {
    const entries = window.performance.getEntriesByType('resource').slice().reverse();
    return entries.find((el) => el.name.endsWith(url));
}
function addLogs(logs, item) {
    logs.push(item);
    if (logs.length > 500) {
        logs.splice(0, 1);
    }
}
function setNowTime(entry, delay, serverTimeUpdate, serverTime) {
    if (!(serverTime && serverTimeUpdate))
        return;
    if (delay > maxDelay)
        return;
    if (NowTime.serverTime > serverTime)
        return;
    if (NowTime.serverTimeUpdate > serverTimeUpdate)
        return;
    if (NowTime.extreme < 2 && (serverTimeUpdate - NowTime.serverTimeUpdate) - (serverTime - NowTime.serverTime) > 30000) {
        NowTime.extreme++;
        return;
    }
    addLogs(NowTime.updateLogs, [
        window.performance?.timeOrigin ?? window.performance?.timing?.navigationStart ?? null,
        entry?.toJSON() ?? entry,
        delay,
        serverTime,
        serverTimeUpdate
    ]);
    NowTime.extreme = 0;
    NowTime.serverTime = serverTime;
    NowTime.serverTimeUpdate = serverTimeUpdate;
}
export const getRelativeTimeByMS = () => Date.now();
export const NowTime = {
    logs: [],
    updateLogs: [],
    extreme: 0,
    serverTime: Date.now(),
    serverTimeUpdate: getRelativeTimeByMS(),
    get() {
        const now = new Date(NowTime.serverTime + (getRelativeTimeByMS() - NowTime.serverTimeUpdate));
        const systemNow = new Date();
        addLogs(NowTime.logs, [now.valueOf(), systemNow.valueOf(), now.valueOf() - systemNow.valueOf()]);
        return now;
    },
    parse(meta, serverTime, config) {
        if (!meta.endTime)
            return;
        if (!serverTime)
            return;
        try {
            const apiEntry = getApiEntry(getFullUrl(config));
            if (!apiEntry)
                throw new Error('Not find ApiEntry');
            const { startTime, responseStart, responseEnd } = apiEntry;
            const delay = ((responseStart || startTime) && responseEnd)
                ? responseEnd - (responseStart || startTime)
                : meta.endTime - meta.startTime;
            setNowTime(apiEntry, delay, meta.endTime, serverTime + delay);
        }
        catch (_) {
            setNowTime(null, meta.endTime - meta.startTime, meta.endTime, serverTime);
        }
    }
};
// debug
window.__now = NowTime;
//# sourceMappingURL=NowTime.js.map